// Layout configuration for the application
// This file defines which pages should use which layouts

export const layoutConfig = {
  // Pages that should not have any layout (no header, footer, etc.)
  noLayoutPaths: [
    "/sign-in",
    "/sign-up",
    "/forget-password",
    "/change-password",
  ],

  // Path patterns that should not have any layout
  noLayoutPatterns: [
    "/verify-token",
    "/new-password",
    "/confirm-email",
    "/email-confirmed",
    "/forget",
    "/change",
    "/sign",
    "/apply",
  ],

  // Dashboard pages that should be standalone (no dashboard layout but still need auth)
  standaloneDashboardPages: [
    "/dashboard/brands/step",
    "/dashboard/cause/step",
    "/dashboard/launch-campaign",
  ],
};

// Helper functions for layout decisions
export const shouldSkipAllLayouts = (path) => {
  return (
    layoutConfig.noLayoutPaths.includes(path) ||
    layoutConfig.noLayoutPatterns.some(
      (pattern) => pattern !== "/" && path.startsWith(pattern),
    )
  );
};

export const isStandaloneDashboardPage = (path) => {
  return layoutConfig.standaloneDashboardPages.some((page) =>
    path.startsWith(page),
  );
};

export const isDashboardPage = (path) => {
  return path.startsWith("/dashboard");
};
